import { useQuery } from '@tanstack/react-query';
import { must, useDb } from './db';

/** «Альбом року»: a student's school year, gathered by itself. */
export interface YearBook {
  firstName: string;
  lastName: string;
  classLabel: string;
  grade: number;
  year: string;
  yearEnds: string;
  lessons: number;
  absent: number;
  grades: number;
  average: number | null;
  best: Array<{ points: number; title: string; subject: string; graded_on: string }>;
  subjects: Array<{ subject: string; average: number; grades: number }>;
  homework: number;
  quizzes: { count: number; percent: number | null };
  puzzles: { days: number; right: number };
  achievements: Array<{ title: string; category: string; level: string; on: string }>;
  clubs: Array<{ title: string; emoji: string | null }>;
  season: {
    key: string;
    stage: number;
    stages: number;
    finished: boolean;
    role: string;
    parts: number;
  } | null;
  letters: number;
}

/** The share of lessons attended, in percent. */
export function attendancePercent(book: Pick<YearBook, 'lessons' | 'absent'>): number {
  return book.lessons === 0 ? 100 : Math.round((100 * (book.lessons - book.absent)) / book.lessons);
}

export function useYearBook(studentId: string) {
  const db = useDb();
  return useQuery({
    queryKey: ['year-book', studentId],
    enabled: studentId !== '',
    queryFn: async () =>
      must(await db.rpc('year_book', { p_student: studentId })) as unknown as YearBook | null,
  });
}
